import { UploadFile } from './upload-file.model';

export class UploadEvent {
    constructor(
        public files: UploadFile[]) {
    }
}


// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/ngx-file-drop/lib/ngx-drop/upload-event.model.ts